import script from "./ConversationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ConversationCard.vue?vue&type=script&setup=true&lang=js"

import "./ConversationCard.vue?vue&type=style&index=0&id=a80c3e3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a80c3e3e"]])

export default __exports__